import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Row,
  Col,
  Radio
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { updatePayoutTerms, getPayoutTerms } from "../../../redux/actions/payoutActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util";
import SingleStep from "./SingleStep";

const history = createBrowserHistory();
let termID;
let isLoading="false";
class EditPayoutTerms extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAYMENT_SETTING',
      path: ["Home", "Edit Payment Term"],
      links: ["home",'payment_terms/edit'],
      submitValue: "Save",
      disabled: false,
      termName: '',
      paymentType: 'SINGLE',
      scheduleType: 'DAILY',
      scheduleValue: 'MONDAY',
      scheduleWeekly: 'MONDAY',
      scheduleMonthly: '5',
      scheduleTwiceFirst: '5',
      scheduleTwiceSecond: '5',
      totalPaymentsPercentage: 0,
      paymentTrigger: '',
      detail: '',
      totalPaymentsPercentageError: false,
      show: false,
      termDetail: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleChange = e => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = (e) => {
    isLoading="true";
    termID = this.props.match.params.termID
      ? this.props.match.params.termID
      : "";

    if(termID){
      this.props.getPayoutTerms(termID);
    }
  }

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.handlePageChange();
  }


  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    
    if (this.props.payoutStatus !== nextProps.payoutStatus) {
      if (nextProps.payoutStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.payoutStatus.message);
        this.setState({ submitValue: "Save", disabled: false });
        window.scrollTo(0, 0);
      }
    }
    if (this.props.termDetail !== nextProps.termDetail) {
      if (nextProps.termDetail) {
        this.setState(nextProps.termDetail.data);

        if(nextProps.termDetail.data.scheduleType == 'WEEKLYON'){
          this.setState({scheduleWeekly: nextProps.termDetail.data.scheduleValue});
        }

        if(nextProps.termDetail.data.scheduleType == 'MONTHLYON'){
          this.setState({scheduleMonthly: nextProps.termDetail.data.scheduleValue});
        }

        if(nextProps.termDetail.data.scheduleType == 'TWICEAMONTHON'){
          let res = nextProps.termDetail.data.scheduleValue.split(",");
          this.setState({scheduleTwiceFirst: res[0], scheduleTwiceSecond: res[1]});
        }

        let arrayData = JSON.parse(nextProps.termDetail.data.detail);
        let detail = arrayData[0]['term'];
        this.setState({
          termDetail: {
            paymentTrigger: nextProps.termDetail.data.paymentTrigger,
            totalPaymentsPercentage: nextProps.termDetail.data.totalPaymentsPercentage,
            detail: detail,
          }
        });
        isLoading="false";
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ submitValue: "Save", disabled: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }
  }

  validate(){
    let status = true;
  
    if(!this.state.termName){
      status = false;
      this.setState({termNameError: 'red'})
    }

    if(this.state.totalPaymentsPercentage !== 100){
      status = false;
      this.setState({totalPaymentsPercentageError: true})
    }else{
      this.setState({totalPaymentsPercentageError: false})
    }

    return status;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let valid = this.validate();
    if(valid){
      let scheduleValue = "";

      if(this.state.scheduleType == 'WEEKLYON'){
        scheduleValue = this.state.scheduleWeekly;
      }

      if(this.state.scheduleType == 'MONTHLYON'){
        scheduleValue = this.state.scheduleMonthly;
      }

      if(this.state.scheduleType == 'TWICEAMONTHON'){
        scheduleValue = this.state.scheduleTwiceFirst+','+this.state.scheduleTwiceSecond;
      }

      const constData = {
        termID: termID,
        totalPaymentsPercentage: this.state.totalPaymentsPercentage,
        paymentTrigger: this.state.paymentTrigger,
        detail: this.state.detail,
        termName: this.state.termName,
        paymentType: this.state.paymentType,
        scheduleType: this.state.scheduleType,
        amountPerDownload: this.state.amountPerDownload,
        amountPerRedemption:  this.state.amountPerRedemption,
        scheduleValue: scheduleValue,
      }
      this.setState({ submitValue: "Saving..", disabled: true });
      this.props.updatePayoutTerms(constData);
    }
  }
  saveTerms = (data) => {
    this.setState({
      totalPaymentsPercentage: data.totalPaymentsPercentage,
      paymentTrigger: data.paymentTrigger,
      detail: JSON.stringify(data.detail),
    });

    if(this.state.termDetail){
      this.state.termDetail.totalPaymentsPercentage = data.totalPaymentsPercentage;
    }

    if(this.state.totalPaymentsPercentageError == true && data.totalPaymentsPercentage == 100){
      this.setState({totalPaymentsPercentageError: false})
    }
  }
  saveTermsTriger = (data) => {
    this.setState({
      totalPaymentsPercentage: data.totalPaymentsPercentage,
      paymentTrigger: data.paymentTrigger,
      detail: JSON.stringify(data.detail),
    });

    this.setState({
      termDetail: {
        paymentTrigger: data.paymentTrigger,
        totalPaymentsPercentage: this.state.termDetail.totalPaymentsPercentage,
        detail: this.state.termDetail.detail,
      }
    });
  }
  render() {
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <form>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <Row>
              {/*Referall System Start*/}
              <Col md={12} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Edit Payment Term
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={4} xs={12}>
                        <ControlLabel>Term Name</ControlLabel>
                        <FormGroup controlId="termName">
                          <FormControl
                            type="text"
                            value={this.state.termName}
                            placeholder="Term Name"
                            onChange={this.handleChange}
                            name="termName"
                            style={{
                              borderColor: this.state
                                .termNameError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <ControlLabel>Payment Type</ControlLabel><br/>
                        <Radio name="paymentType" defaultChecked={(this.state.paymentType == 'SINGLE') ? true : false} value="SINGLE" onClick={this.handleChange} inline>Single Step</Radio>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <SingleStep isError={this.state.totalPaymentsPercentageError} termDetail={this.state.termDetail} saveTerms={this.saveTerms.bind(this)} saveTermsTriger = {this.saveTermsTriger.bind(this)} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Schedule</ControlLabel><br/>
                      </Col>
                      <Col md={12} xs={12}>
                        <Radio name="scheduleType" checked={(this.state.scheduleType == 'DAILY') ? true : false} value="DAILY" onClick={this.handleChange}  inline>Daily</Radio>
                      </Col>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={4} xs={12}>
                            <Radio name="scheduleType" checked={(this.state.scheduleType == 'WEEKLYON') ? true : false} value="WEEKLYON" onClick={this.handleChange}   inline>Weekly on</Radio>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormControl
                              componentClass="select"
                              style={{ borderColor: this.state.scheduleWeeklyError }}
                              name="scheduleWeekly"
                              onChange={this.handleChange}
                              value={this.state.scheduleWeekly}
                              disabled={(this.state.scheduleType == 'WEEKLYON') ? false : true}
                            >
                              <option value="MONDAY">Monday</option>
                              <option value="TUESDAY">Tuesday</option>
                              <option value="WEDNESDAY">Wednesday</option>
                              <option value="THURSDAY">Thursday</option>
                              <option value="FRIDAY">Friday</option>
                              <option value="SATURDAY">Saturday</option>
                              <option value="SUNDAY">Sunday</option>
                            </FormControl>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={4} xs={12}>
                            <Radio name="scheduleType" checked={(this.state.scheduleType == 'MONTHLYON') ? true : false} value="MONTHLYON" onClick={this.handleChange}   inline>Monthly on </Radio>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormControl
                              componentClass="select"
                              style={{ borderColor: this.state.scheduleMonthlyError }}
                              name="scheduleMonthly"
                              onChange={this.handleChange}
                              value={this.state.scheduleMonthly}
                              disabled={(this.state.scheduleType == 'MONTHLYON') ? false : true}
                            >
                              {[...Array(31)].map((x, i) =>
                                <option value={i+1}>{i+1}</option>
                              )}
                            </FormControl>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={4} xs={12}>
                            <Radio name="scheduleType" checked={(this.state.scheduleType == 'TWICEAMONTHON') ? true : false} value="TWICEAMONTHON" onClick={this.handleChange}  inline>Twice a Month on</Radio>
                          </Col>
                          <Col md={2} xs={12}>
                            <FormControl
                              componentClass="select"
                              style={{ borderColor: this.state.scheduleTwiceFirstError }}
                              name="scheduleTwiceFirst"
                              onChange={this.handleChange}
                              value={this.state.scheduleTwiceFirst}
                              disabled={(this.state.scheduleType == 'TWICEAMONTHON') ? false : true}
                            >
                              {[...Array(31)].map((x, i) =>
                                <option value={i+1}>{i+1}</option>
                              )}
                            </FormControl>
                          </Col>
                          <Col md={2} xs={12}>
                            <FormControl
                              componentClass="select"
                              style={{ borderColor: this.state.scheduleTwiceSecondError }}
                              name="scheduleTwiceSecond"
                              onChange={this.handleChange}
                              value={this.state.scheduleTwiceSecond}
                              disabled={(this.state.scheduleType == 'TWICEAMONTHON') ? false : true}
                            >
                              {[...Array(31)].map((x, i) =>
                                <option value={i+1}>{i+1}</option>
                              )}
                            </FormControl>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} xs={12}>
                        <ControlLabel>Amount Per Download</ControlLabel>
                        <FormGroup controlId="amountPerDownload">
                          <FormControl
                            type="text"
                            value={this.state.amountPerDownload}
                            placeholder="Amount Per Download"
                            onChange={this.handleChange}
                            name="amountPerDownload"
                            style={{
                              borderColor: this.state
                                .amountPerDownloadError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <ControlLabel>Amount Per Redemption</ControlLabel>
                        <FormGroup controlId="amountPerRedemption">
                          <FormControl
                            type="text"
                            value={this.state.amountPerRedemption}
                            placeholder="Amount Per Redemption"
                            onChange={this.handleChange}
                            name="amountPerRedemption"
                            style={{
                              borderColor: this.state
                                .amountPerRedemptionError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
            
            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  id="saveButton"
                  disabled={this.state.disabled}
                  onClick={this.handleSubmit}
                >
                  {this.state.submitValue}
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => this.context.router.history.push(`/payout-terms/list`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    );
  }
}

EditPayoutTerms.propTypes = {
  updatePayoutTerms: PropTypes.func.isRequired,
  getPayoutTerms: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: state.payoutReducer.error,
  payoutStatus: state.payoutReducer.payoutStatus,
  termDetail: state.payoutReducer.termDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default withRouter(connect(mapStateToProps, {
  renderAlert,
  clearAlert,
  updatePayoutTerms,
  getPayoutTerms
})(EditPayoutTerms));



// WEBPACK FOOTER //
// ./src/app/views/admin/payoutTerms/EditPayoutTerms.js